import React from 'react';

const SidebarSmall = () => {
  return (
    <nav className="navbar navbar-dark navbar-theme-primary px-4 col-12 d-md-none">
      <img className="navbar-brand-dark" src="/img/expolon-logo-text-light.svg" alt="" />
      <div className="d-flex align-items-center">
        <button className="navbar-toggler d-md-none collapsed" type="button" data-toggle="collapse" data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>
  );
}

export default SidebarSmall;
